import React, { useContext } from 'react';

import NavSideBarContext from 'contexts/NavSideBarContext';
import GlobalSearch from 'components/GlobalSearch';
import AccountPicker from 'components/AccountPicker';
import Row from 'components/Common/Row';
import AppRoutes from 'navigation/appRoutes';
import styled from 'styled-components';

import MainNavTop from '../MainNavTop';
import NavSection from '../NavSection';
import NavItem from '../NavItem';
import MainNavBottom from '../MainNavBottom';
import MainNavFavouritesSection from '../MainNavFavouritesSection';
import NAVIGATION from '../constants';
import FavoritesSection from '../FavoritesSection';
import PortalPicker from '../PortalPicker';
import PortalNavSection from './PortalNavSection';

export const MainNavDiv = styled.div<{ isCollapsed: boolean }>`
  width: ${(props) =>
    props.isCollapsed
      ? NAVIGATION.COLLAPSED_NAV_WIDTH
      : NAVIGATION.OPENED_NAV_WIDTH}px;
  min-width: ${(props) =>
    props.isCollapsed
      ? NAVIGATION.COLLAPSED_NAV_WIDTH
      : NAVIGATION.OPENED_NAV_WIDTH}px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--color-bg-secondary);
  justify-content: space-between;
  border-right: 1px solid var(--color-border-secondary);
`;

export const MainNavPrimaryContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: scroll;
`;

/**
 *
 * Some customers, such as Nagle, have a "Portals" UI rolled
 * out to them and are not yet introduced to the "Apps" UI.
 *
 * */
const PortalsMainNav = () => {
  const { isOpen } = useContext(NavSideBarContext);

  return (
    <Row>
      <MainNavDiv isCollapsed={!isOpen}>
        <MainNavPrimaryContent>
          <MainNavTop />
          <NavSection>
            <AccountPicker />
            <GlobalSearch />
            <MainNavFavouritesSection />
            <NavItem
              to={AppRoutes.loggedIn.workspaces}
              label={'Workspaces'}
              tooltip={'Workspaces'}
              icon={'workspace'}
              onClickEvent={'Navigation Sidebar - Clicked Workspaces'}
            />
            <NavItem
              to={AppRoutes.loggedIn.shared}
              label={'Shared'}
              tooltip={'Shared'}
              icon={'shared'}
              onClickEvent={'Navigation Sidebar - Clicked Shared'}
            />
          </NavSection>
          <NavSection hideBorderBottom>
            <PortalPicker />
          </NavSection>
          <PortalNavSection />
        </MainNavPrimaryContent>
        <MainNavBottom />
      </MainNavDiv>
      <FavoritesSection />
    </Row>
  );
};

export default PortalsMainNav;
